/** Five taps within this window open Losi Games. */
export const LOSI_GAMES_TAP_WINDOW_MS = 4200
export const LOSI_GAMES_TAP_TARGET = 5

export class LosiGamesTapRitual {
  private taps: number[] = []

  /** Returns true when the 5th tap in-window lands. */
  tap(now = Date.now()): boolean {
    const cutoff = now - LOSI_GAMES_TAP_WINDOW_MS
    this.taps = this.taps.filter((t) => t >= cutoff)
    this.taps.push(now)
    if (this.taps.length >= LOSI_GAMES_TAP_TARGET) {
      this.taps = []
      return true
    }
    return false
  }

  count(now = Date.now()): number {
    const cutoff = now - LOSI_GAMES_TAP_WINDOW_MS
    this.taps = this.taps.filter((t) => t >= cutoff)
    return this.taps.length
  }

  reset() {
    this.taps = []
  }
}
